import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, Typography } from "@mui/material"
import { testoRiabilitaOne } from "../../../const/Dialog/Disabilita/dialogDisabilitaText"
import { dialogButtonGeneral } from "../../../const/DialogData"
import ButtonRipristinaUnaPostazione from "./ButtonRipristinaUnaPostazione"
import { useTranslation } from "react-i18next";

export default function RipristinaUnaPostazione({isOpen= false, handlerBlur, rowInfo = false, change, closeForm, dialogType }){
  const { t } = useTranslation();

    return (
        <>
        <Dialog
            open={isOpen}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
            maxWidth={'sm'}
          >
            <DialogTitle >{t("restore_v2")}</DialogTitle>
            <DialogContent className="border-Content-dialog">
                <FormControl fullWidth>
                <DialogContentText id="alert-dialog-description">
                {testoRiabilitaOne(t,rowInfo.posto)}
                </DialogContentText>
                </FormControl>
                </DialogContent>
                <DialogActions 
                  >
                  <Button onClick={() => closeForm()} >
                    {t(dialogButtonGeneral.Cancel)}
                  </Button>
                   {/* <ButtonBoxRiattivaTuttePostazioni buttonText={t(dialogButtonGeneral.Confirm)}/>  */}
                   <ButtonRipristinaUnaPostazione rowInfo={rowInfo} />
                </DialogActions>
          </Dialog>
          </>
    )
}